import React, { useState } from 'react';
import { useListEditor } from '../hooks/useListEditor';

const MAX_SIZE_MB = 2;

export default function TrainingSliderEditor({ cards, onChange }) {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [image, setImage] = useState('');
  const [imgError, setImgError] = useState('');
  const [fileName, setFileName] = useState(null);
  const { editIndex, select, clear, isEditing } = useListEditor(() => {
    setTitle('');
    setBody('');
    setImage('');
    setImgError('');
    setFileName(null);
  });

  const handleSelectCard = (i) => {
    const card = cards[i];
    setTitle(card.title);
    setBody(card.body);
    setImage(card.image);
    setImgError('');
    select(i);
  };

  const handleImageFile = (file) => {
    if (!file) return;
    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      setImgError(`La imagen supera el límite de ${MAX_SIZE_MB} MB.`);
      return;
    }
    setImgError('');
    const reader = new FileReader();
    reader.onload = (e) => setImage(e.target.result);
    reader.readAsDataURL(file);
  };

  const handleSave = () => {
    if (!title.trim()) return;
    if (isEditing) {
      onChange(cards.map((c, i) => i === editIndex ? { ...c, title: title.trim(), body: body.trim(), image } : c));
    } else {
      onChange([...cards, { _id: crypto.randomUUID(), title: title.trim(), body: body.trim(), image }]);
    }
    clear();
  };

  const handleRemove = (e, i) => {
    e.stopPropagation();
    onChange(cards.filter((_, idx) => idx !== i));
    if (editIndex === i) clear();
  };

  return (
    <>
      <div className="content-editor-add-form mb-3">
        <div className="form-group mb-2">
          <label className="form-label">Titulo</label>
          <input type="text" className="form-control" value={title}
            onChange={(e) => setTitle(e.target.value)} placeholder="Titulo de la card" />
        </div>
        <div className="form-group mb-2">
          <label className="form-label">Texto</label>
          <textarea className="form-control" rows="3" value={body}
            onChange={(e) => setBody(e.target.value)} placeholder="Contenido..." />
        </div>
        <div className="form-group mb-2">
          <label className="form-label">Imagen</label>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              cursor: "pointer",
              width: "100%",
            }}
          >
            <span
              style={{
                padding: "6px 14px",
                borderRadius: 6,
                border: "1px solid #ced4da",
                background: "#f8f9fa",
                color: "#495057",
                fontSize: 14,
                fontWeight: 500,
                whiteSpace: "nowrap",
                userSelect: "none",
              }}
            >
              Elegir imagen
            </span>
            <span
              style={{
                flex: 1,
                fontSize: 14,
                color: "#6c757d",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {fileName || "Sin archivo seleccionado"}
            </span>
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files[0];
                setFileName(file ? file.name : null);
                handleImageFile(file);
              }}
            />
          </label>
          {imgError && <div className="text-danger small mt-1">{imgError}</div>}
          {image && (
            <div className="mt-2 d-flex align-items-center gap-2">
              <img src={image} alt="preview" style={{ maxHeight: 80, maxWidth: 120, objectFit: 'contain', borderRadius: 4, border: '1px solid #e2e8f0' }} />
              <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setImage('')}>
                <i className="fas fa-times" /> Quitar
              </button>
            </div>
          )}
        </div>
        <div className="d-flex gap-2">
          <button type="button" className="btn btn-secondary" onClick={handleSave}>
            {isEditing ? 'Guardar cambios' : 'Añadir card'}
          </button>
          {isEditing && (
            <button type="button" className="btn btn-outline-secondary" onClick={clear}>
              Cancelar
            </button>
          )}
        </div>
      </div>
      {cards.length === 0 ? (
        <div className="blocks-list-empty">Sin cards aún</div>
      ) : (
        <div className="content-editor-list">
          {cards.map((card, i) => (
            <div key={card._id || i} className={`content-editor-list-item ${editIndex === i ? 'selected' : ''}`}
              onClick={() => handleSelectCard(i)} style={{ cursor: 'pointer' }}>
              <span className="blocks-list-index">{i + 1}</span>
              <span className="blocks-list-name">{card.title}</span>
              <button type="button" className="blocks-list-remove" onClick={(e) => handleRemove(e, i)}>x</button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
